import Gallery from "./components/Gallery";

export default function GalleryPage () {
    return(
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold text-center my-6">Welcome to Our Gallery</h1>
            <div>
                <Gallery />
            </div>
        </div>
    );
}